import { useTranslation } from 'react-i18next';

export default function TableRss(){
  const {t} = useTranslation();
  const prefix = 'optimizers.company.ti.products.7.details.table.';

  const trStyle = 'border-[1.5px] border-t-gray-300 border-r-transparent';
  const thStyle='px-2 lg:w-[170px] bg-[#EDEDED] text-gray-600 text-light text-sm lg:text-base';
  const tdStyle='px-4 py-4 lg:w-[510px] text-xs lg:text-sm text-gray-600 border border-t-gray400 border-r-transparent';
  const tdTopStype='border-[1px] px-4 py-4 lg:w-[510px] text-xs lg:text-sm text-gray-600 border border-t-gray400 border-r-transparent';
  return (
    <table>
      <tbody>
        <tr className='border border-t-hover'>
          <th rowSpan={2} className={thStyle}>{t(`${prefix}1`)}</th>
          <td className='lg:w-[340px] px-4 py-4 text-gray-600 text-xs lg:text-sm border border-t-hover border-r-transparent'>{t(`${prefix}2`)}</td>
        </tr>
        <tr>
          <td className={tdStyle}>{t(`${prefix}3`)}</td>
        </tr>
        <tr className={trStyle}>
          <th rowSpan={4} className={thStyle}>{t(`${prefix}4`)}</th>
          <td className={tdTopStype}>{t(`${prefix}5`)}</td>
        </tr>
        <tr>
          <td className={tdStyle}>{t(`${prefix}6`)}</td>
        </tr>
        <tr>
          <td className={tdStyle}>{t(`${prefix}7`)}</td>
        </tr>
        <tr>
          <td className={tdStyle}>{t(`${prefix}8`)}</td>
        </tr>
        <tr className={trStyle}>
          <th rowSpan={3} className={thStyle}>{t(`${prefix}9`)}</th>
          <td className={tdTopStype}>{t(`${prefix}10`)}</td>
        </tr>
        <tr>
          <td className={tdStyle}>{t(`${prefix}11`)}</td>
        </tr>
        <tr>
          <td className={tdStyle}>{t(`${prefix}12`)}</td>
        </tr>
      </tbody>
    </table>
  );
}